<template>
    <div class="card" style="width: 1500px; max-width: 100%;">
        <div class="card-modal" style="overflow: auto; max-height: 700px;">
            <b-loading :is-full-page="true" v-model="loading" :can-cancel="false"></b-loading>

            <header class="modal-card-head">
                <p class="modal-card-title">{{ title }}</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>

            <section class="modal-card-body">
                <div>
                    <span class="is-size-4">Rule Actions</span><br /><br />
                    <b-field>
                        <b-radio-button v-model="rule.useCustomActions" :native-value="false" type="is-primary">
                            <span>Apply same actions as overall policy</span>
                        </b-radio-button>
                        <b-radio-button v-model="rule.useCustomActions" :native-value="true" type="is-primary">
                            <span>Configure custom actions</span>
                        </b-radio-button>
                    </b-field>
                </div>
                <br>
                <Actions v-if="rule.useCustomActions" :travelPolicy="null" @actionsData="getActionData"
                    :approvalLevel="rule.approvalLevel" :visibility="rule.visibility"
                    :notifications="rule.notifications" />
                <br />
            </section>

            <footer class="modal-card-foot">
                <b-button label="Close" @click="$emit('close')" />
                <b-button @click="submit()" class="button is-primary is-wide">
                    Save
                </b-button>
            </footer>
        </div>
    </div>
</template>

<script>
import Actions from "./Actions.vue";

export default {
    name: "StandardRuleModal",
    components: {
        Actions
    },
    props: {
        ruleObj: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: "Rule"
        }
    },
    data() {
        return {
            loading: false,
            rule: {
                name: this.ruleObj.name || "",
                isActive: this.ruleObj.isActive ?? true,
                type: this.ruleObj.type || "air",
                message: this.ruleObj.message || "",
                useCustomActions: this.ruleObj.useCustomActions ?? false,
                visibility: this.ruleObj.visibility ?? (this.ruleObj.useCustomActions ? "hide" : undefined),
                approvalLevel: this.ruleObj.approvalLevel ?? (this.ruleObj.useCustomActions ? "soft" : undefined),
                notifications: this.ruleObj.notifications ?? (this.ruleObj.useCustomActions ? {
                    managerViaEmail: false,
                    managerViaSms: false,
                    email: [],
                    sms: []
                } : undefined)
            }
        };
    },
    computed: {
        headerText() {
            return this.rule.name || "Rule Configuration";
        }
    },
    methods: {
        getActionData(val) {
            if (this.rule.useCustomActions) {
                this.rule.approvalLevel = val.approvalLevel;
                this.rule.visibility = val.visibility;
                this.rule.notifications = val.notifications;
            }
        },
        submit() {
            const payload = {
                name: this.rule.name,
                isActive: this.rule.isActive,
                type: this.rule.type,
                message: this.rule.message,
                useCustomActions: this.rule.useCustomActions,
            };

            // Only include these properties if useCustomActions is true
            if (this.rule.useCustomActions) {
                payload.visibility = this.rule.visibility;
                payload.approvalLevel = this.rule.approvalLevel;
                payload.notifications = this.rule.notifications;
            }

            this.$emit("save", payload);
            this.$emit("close");
        }

    }
};
</script>

<style scoped>
.is-less-bottom {
    margin-bottom: -20px;
}
</style>
